import { inject, Injectable } from '@angular/core';
import { ChatApiService } from './chat-api.service';
import { ChatWsActionsService } from './chat-ws-actions.service';
import { ChatWsListenersService } from './chat-ws-listeners.service';
import { ChatWsService } from './chat-ws.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  readonly #chatWsService = inject(ChatWsService);
  readonly #chatApiService = inject(ChatApiService);
  readonly #listeners = inject(ChatWsListenersService);
  readonly #wsActions = inject(ChatWsActionsService);

  get wsActions() {
    return this.#wsActions;
  }
  get api() {
    return this.#chatApiService;
  }
  public init() {
    this.#chatWsService.connect();
    this.#listeners.init();
  }
}
